import { Component } from '@angular/core';

@Component({
  selector: 'app-audit',
  templateUrl: './auditoria.component.html',
  styleUrls: ['./auditoria.component.scss'],
})
export class AuditoriaComponent {}
